export enum ChatMessageType {
	TextImage = 'text_image',
	Sticker = 'sticker',
	Gif = 'gif',
	SystemNotification = 'system_notification',
}
